import { BdEquals } from '@bindoc-projects/util-domain-lib';

export class VirtualClinicAnalysisFilterHybridDrg {
  public static fromObject(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    obj: any = {},
  ): VirtualClinicAnalysisFilterHybridDrg {
    const hybridDrgVersionYear = typeof obj.hybridDrgVersionYear === 'string'
      ? Number(obj.hybridDrgVersionYear.trim())
      : obj.hybridDrgVersionYear;
    return new VirtualClinicAnalysisFilterHybridDrg(
      hybridDrgVersionYear,
      obj.ops_p115f_a1_s1_n2_sgb ?? null,
      obj.icdNichtAmbulant ?? null,
      obj.opsStationaer ?? null,
      obj.funktionseinschraenkungen ?? null,
      obj.pflegegrad ?? null,
      obj.beatmung ?? null,
      obj.altersgrenze ?? null,
      obj.beidseitig ?? null,
      obj.ophthalm ?? null,
      obj.belegungstage_lt_2 ?? null,
      obj.pccl_lt_3 ?? null,
      obj.keine_neubildungen ?? null,
      obj.ze_diagnosen ?? null,
      obj.ze_prozeduren ?? null,
    );
  }

  constructor(
    public hybridDrgVersionYear: number = 2025,
    public ops_p115f_a1_s1_n2_sgb: boolean | null = true,
    public icdNichtAmbulant: boolean | null = true,
    public opsStationaer: boolean | null = true,
    public funktionseinschraenkungen: boolean | null = true,
    public pflegegrad: boolean | null = true,
    public beatmung: boolean | null = true,
    public altersgrenze: boolean | null = true,
    public beidseitig: boolean | null = true,
    public ophthalm: boolean | null = true,
    public belegungstage_lt_2: boolean | null = true,
    public pccl_lt_3: boolean | null = true,
    public keine_neubildungen: boolean | null = true,
    public ze_diagnosen: boolean | null = true,
    public ze_prozeduren: boolean | null = true,
  ) {}

  public clone(): VirtualClinicAnalysisFilterHybridDrg {
    return new VirtualClinicAnalysisFilterHybridDrg(
      this.hybridDrgVersionYear,
      this.ops_p115f_a1_s1_n2_sgb,
      this.icdNichtAmbulant,
      this.opsStationaer,
      this.funktionseinschraenkungen,
      this.pflegegrad,
      this.beatmung,
      this.altersgrenze,
      this.beidseitig,
      this.ophthalm,
      this.belegungstage_lt_2,
      this.pccl_lt_3,
      this.keine_neubildungen,
      this.ze_diagnosen,
      this.ze_prozeduren,
    );
  }

  public equals(toCompare: VirtualClinicAnalysisFilterHybridDrg): boolean {
    return (
      !!toCompare &&
      BdEquals.equals(
        this.hybridDrgVersionYear,
        toCompare.hybridDrgVersionYear,
      ) &&
      this.ops_p115f_a1_s1_n2_sgb === toCompare.ops_p115f_a1_s1_n2_sgb &&
      this.icdNichtAmbulant === toCompare.icdNichtAmbulant &&
      this.opsStationaer === toCompare.opsStationaer &&
      this.funktionseinschraenkungen === toCompare.funktionseinschraenkungen &&
      this.pflegegrad === toCompare.pflegegrad &&
      this.beatmung === toCompare.beatmung &&
      this.altersgrenze === toCompare.altersgrenze &&
      this.beidseitig === toCompare.beidseitig &&
      this.ophthalm === toCompare.ophthalm &&
      this.belegungstage_lt_2 === toCompare.belegungstage_lt_2 &&
      this.pccl_lt_3 === toCompare.pccl_lt_3 &&
      this.keine_neubildungen === toCompare.keine_neubildungen &&
      this.ze_diagnosen === toCompare.ze_diagnosen &&
      this.ze_prozeduren === toCompare.ze_prozeduren
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toJSON(): any {
    return {
      hybridDrgVersionYear: this.hybridDrgVersionYear,
      ops_p115f_a1_s1_n2_sgb: this.ops_p115f_a1_s1_n2_sgb,
      icdNichtAmbulant: this.icdNichtAmbulant,
      opsStationaer: this.opsStationaer,
      funktionseinschraenkungen: this.funktionseinschraenkungen,
      pflegegrad: this.pflegegrad,
      beatmung: this.beatmung,
      altersgrenze: this.altersgrenze,
      beidseitig: this.beidseitig,
      ophthalm: this.ophthalm,
      belegungstage_lt_2: this.belegungstage_lt_2,
      pccl_lt_3: this.pccl_lt_3,
      keine_neubildungen: this.keine_neubildungen,
      ze_diagnosen: this.ze_diagnosen,
      ze_prozeduren: this.ze_prozeduren,
    };
  }
}
